module.exports = "<ui-view>\n  <app-contact-form [routePrefix]=\"routePrefix\" [contactFilter]=\"contactFilter\"></app-contact-form>\n</ui-view>\n"


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/building/building-contact-form.component.html
// module id = ../../../../../src/app/components/building/building-contact-form.component.html
// module chunks = main